import { Route } from 'types/route.type';
import ListNotifications from './list-notifications';

export const routes: Route[] = [
  {
    path: '/planning-prognosis/notifications/:tab',
    component: ListNotifications,
    id: 'planningPrognosis.navigation.listNotifications',
  },
];
